import { LandRegistry } from './landRegistry';
import { FieldGroup } from './fieldGroup';
import { Farm } from './farm';
import { FieldActivity } from '../_models';
import { Crop } from './crop';
import { ABLine } from './abLine';
import { ObstaclePolygon } from './obstaclePolygon';
import { Parcel } from './parcel';
import { TenantGeneralData } from './tenantGeneralData';
import { PacProperties } from './pacProperties';

export class Field extends TenantGeneralData {
  name: string;
  geoJsonArea: string;
  area: JSON;
  staticMapUrl: string;
  country: string;
  countryCode: string;
  city: string;
  cadastralSheet: string;
  cadastralParcel: string;
  // cadastralArea: string;
  ownerName: string;
  managementType: string;
  note: string;
  granulometry: string;
  listedInCAP: boolean;
  size: number;
  sizeUnit: 'ha' | 'm2' = 'ha';
  irrigationCapacity: number;
  irrigationCapacityUnit: 'l/s' | 'm3/h' | 'l/min' | 'l/h' | 'mm';
  type: string;
  coversType: string;
  group: FieldGroup;
  farm: Farm | string | number;
  crops: Array<Crop>;
  activities: Array<FieldActivity>;
  fieldActivities: Array<FieldActivity>;
  lastActivity: FieldActivity;
  landRegistries: Array<LandRegistry>;
  tags: string[];
  sand: number;
  slime: number;
  argil: number;
  pH: string;

  plantsCount = 0;
  plantsX = 0;
  plantsY = 0;
  plantsPlantingDate: Date;
  plantsCuttingDate: string;
  plantsHarvestingDate: string;
  plantsUpdateDate: Date;
  plantsNote: string;

  limescale: string;
  activeLimescale: string;
  organicSubstance: string;
  organicCarbon: string;
  mineralNitrogen: string;
  soilUrl: string;
  irrigationMethod: string;
  waterSource: string;
  satelliteImageDatesByIndex: Array<any>;
  polygon = null;
  trackTelemetryActivity: boolean = true;
  virtualField?: boolean;
  abLines: Array<ABLine>;
  polygonObstacles: Array<ObstaclePolygon>;
  dataFromImport?: null;
  companyName?: string;
  ecoschema: string;
  disable?: boolean;
  allMultiYearCrops?: any;
  singleYearCrops?: any;
  // Array of Parcels is not same collection of Field but it can be appended in same components for easiness of data usage
  parcels?: Array<Parcel>;
  // Array containing information related to the CAP for the field
  pacProperties?: Array<PacProperties>;
  validGeometry?: boolean;
  // Indicates if the field overlooks a public street or urban area
  overlookPublicStreet?: boolean;

  constructor() {
    super();
    this.name = null;
    this.geoJsonArea = null;
    this.area = null;
    this.staticMapUrl = null;
    this.country = null;
    this.countryCode = null;
    this.city = null;
    this.cadastralSheet = null;
    this.cadastralParcel = null;
    this.ownerName = null;
    this.managementType = null;
    this.note = null;
    this.granulometry = null;
    this.listedInCAP = null;
    this.size = null;
    this.sizeUnit = null;
    this.irrigationCapacity = null;
    this.irrigationCapacityUnit = null;
    this.type = null;
    this.coversType = null;
    this.group = null;
    this.farm = null;
    this.crops = [];
    this.activities = [];
    this.fieldActivities = [];
    this.lastActivity = null;
    this.landRegistries = [];
    this.tags = [];
    this.sand = null;
    this.slime = null;
    this.argil = null;
    this.pH = null;

    this.plantsCount = null;
    this.plantsX = null;
    this.plantsY = null;
    this.plantsPlantingDate = null;
    this.plantsCuttingDate = null;
    this.plantsHarvestingDate = null;
    this.plantsUpdateDate = null;
    this.plantsNote = null;

    this.limescale = null;
    this.activeLimescale = null;
    this.organicSubstance = null;
    this.organicCarbon = null;
    this.mineralNitrogen = null;
    this.soilUrl = null;
    this.irrigationMethod = null;
    this.waterSource = null;
    this.satelliteImageDatesByIndex = [];
    this.polygon = null;
    this.trackTelemetryActivity = true;
    this.abLines = [];
    this.polygonObstacles = [];
    this.dataFromImport = null;
    this.companyName = null;
    this.ecoschema = null;
    this.disable = null;
    this.pacProperties = null;
    this.validGeometry = null;
    this.overlookPublicStreet = false;
  }
}
